/* eslint 'array-callback-return': 'off','no-new-object': 'off','no-array-constructor': 'off','no-redeclare': 'off', 'jsx-a11y/anchor-is-valid': 'off'  */
import React, { Component } from 'react';
import SearchInput, { createFilter } from 'react-search-input';
import { Table } from 'reactstrap';

const KEYS_TO_FILTERS = ['Name','Location'];

export default class SearchableDropDown extends Component {

    constructor(props) {
        super(props);
        this.state = {
            searchTerm: '',
        }
        this.searchUpdated = this.searchUpdated.bind(this);
        this.selectOption = this.selectOption.bind(this);
    }   

    searchUpdated(term) {
        this.setState({ searchTerm: term })
    }

    selectOption(id,name,subId,buildingId){
        this.props.setValue(id,name,subId,buildingId);
    }

    UnCheckAll(){
        this.props.setValue(0,'',0,0);
    }

    render(){
        var data = this.props.data;
        let FilteredData, Tenants;
        let SelectedData ='';

        if (data !== undefined && data.length > 0 && data !== null) {

            FilteredData = data.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS));
            if (FilteredData.length !== 0) {
                Tenants = FilteredData.map(el =>{
                    var HasChecked = this.props.selectedID=== el.Id? true:false;
                    if(HasChecked){
                        SelectedData = el;
                    }else{
                    return <tr key={el.Id}>
                        <th style={{width:"5%", bordertop: "0 solid"}}><input type="radio" checked={HasChecked}  id={el.Id} name={this.props.groupname} data-value={el.Name} onChange={() =>{this.selectOption(el.Id,el.Name,el.SubId,el.BuildingId)}}/></th>
                        {
                            (el.Location !== "" && el.Location !== null) ? 
                            <td style={{width:"50%", bordertop: "0 solid"}}>{el.Name}<b>  {'-->'}  </b>{el.Location}</td> : 
                            <td style={{width:"50%", bordertop: "0 solid"}}>{el.Name}</td>
                        }
                    </tr>
                        }
                    });
                }
            else {
                Tenants = <tr><td colSpan="3">No Records found</td></tr>
            }
        }
        else {
               Tenants = <tr><td colSpan="3">No Records found</td></tr>
        }
        return(
            <div ref={this.props.refMethod} style={this.props.elementStyle}>
            <SearchInput className="search-input multiselect" onChange={this.searchUpdated} style={{width:"370px",float:"right","margin-top":"5px","margin-bottom":"5px","margin-left":"6px","margin-right":"6px",height:'40px'}} />
                <a className="nv_link link_cursor" style={{"width":"35px","float":"right","margin-right":"4px"}} onClick={() => { this.UnCheckAll()}}>Reset</a>
                <Table style={{ bordertop: "0 solid" }}>
                    <tbody>
                        {
                            SelectedData !== ""?
                            <tr key={SelectedData.tenantId}>
                                <th style={{width:"5%", bordertop: "0 solid"}}><input type="radio" checked="true"  id={SelectedData.Id} name={this.props.groupname} data-value={SelectedData.Name} onChange={() =>{this.selectOption(SelectedData.Id,SelectedData.Name,SelectedData.SubId)}}/></th>
                                {
                                    SelectedData.Location !== "" ? 
                                    <td style={{width:"50%", bordertop: "0 solid"}}>{SelectedData.Name}<b> {'-->'}  </b>{SelectedData.Location }</td> :
                                    <td style={{width:"50%", bordertop: "0 solid"}}>{SelectedData.Name}</td>
                                }
                            </tr>:""
                        }
                        {Tenants}
                    </tbody>
                </Table>
            </div>
        );
    }
}